export default function MarketplaceShell({ children }) {
  return (
    <div className="myboothshare-shell min-h-screen">
      <main className="mx-auto max-w-[1400px] px-4 py-8 md:px-6">{children}</main>
    </div>
  );
}
